import { render, staticRenderFns } from "./CertificatesForm.vue?vue&type=template&id=634c4968&"
import script from "./CertificatesForm.vue?vue&type=script&lang=js&"
export * from "./CertificatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports